import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// --- Interfaces ---
import type { ITheme, IThemes } from '@interfaces/appearance';

export interface IThemesState extends IThemes {}

export const INITIAL_STATE: IThemesState = {
	metadata: {
		page: 0,
		pageLimit: 0,
		count: 0,
		totalItems: 0,
	},
	result: [],
};

@Injectable({
	providedIn: 'root',
})
export class ThemesStore {
	private _themesState = new BehaviorSubject<IThemesState>(INITIAL_STATE);
	readonly themesState$ = this._themesState.asObservable();

	constructor() {}

	updateThemes(themes: IThemesState) {
		const state = this._themesState.value;

		const data = {
			...state,
			...themes,
		};

		this._themesState.next(data);

		return this._themesState.asObservable();
	}

	updateTheme(theme: ITheme) {
		const state = this._themesState.value;

		const themeIndex = state.result.findIndex(({ id }) => id === theme.id);

		if (themeIndex >= 0) {
			state.result[themeIndex] = { ...state.result[themeIndex], ...theme };
		} else {
			state.result.push(theme);
		}

		const data = state;

		this._themesState.next(data);

		return this._themesState.asObservable();
	}

	deleteTheme(themeId: ITheme['id']) {
		const state = this._themesState.value;

		const themeIndex = state.result.findIndex(({ id }) => id === themeId);

		state.result.splice(themeIndex, 1);

		const data = state;

		this._themesState.next(data);

		return this._themesState.asObservable();
	}
}
